import { delay } from "utils/delay";

export const fetchWithRetry = async (
  url: RequestInfo | URL,
  options?: RequestInit,
  retries = 2
): Promise<Response> => {
  try {
    const response = await fetch(url, options);

    if (response.ok) {
      return response;
    }

    if (retries > 0) {
      await delay(1000);
      return fetchWithRetry(url, options, retries - 1);
    } else {
      throw Error(FETCH_RETRY_EXCEEDED_ERROR);
    }
  } catch (error) {
    if (retries > 0 && error instanceof Error && error.message !== FETCH_RETRY_EXCEEDED_ERROR) {
      await delay(1000);
      return fetchWithRetry(url, options, retries - 1);
    } else {
      throw error;
    }
  }
};

const FETCH_RETRY_EXCEEDED_ERROR = "FETCH_RETRY_EXCEEDED";
